<template>
  <div class="rmr-page-shell social-reporting-page">
    <rmr-page-hero
      title="Reporting"
      title-accent="Social"
      subtitle="Publications, performances et comptes sociaux collectés depuis Nonli"
      :icon="icons.mdiChartTimelineVariant"
    >
      <template #actions>
        <social-reporting-health />
        <rmr-icon-button
          :icon="icons.mdiHelpCircleOutline"
          tooltip="Comprendre le fonctionnement de la page"
          @click="showHelp = true"
        />
      </template>
    </rmr-page-hero>

    <social-reporting-help-modal v-model="showHelp" />

    <section class="rmr-page-shell__content social-reporting-page__content">
      <div class="rmr-table-shell social-reporting-page__panel">
        <div class="social-reporting-page__tabs">
          <rmr-tabs v-model="activeTab" :tabs="tabs" show-arrows />
        </div>

        <keep-alive>
          <social-reporting-resource
            :key="activeResource"
            :resource="activeResource"
          />
        </keep-alive>
      </div>
    </section>
  </div>
</template>

<script>
import {
  mdiAccountMultipleOutline,
  mdiChartTimelineVariant,
  mdiHelpCircleOutline,
  mdiPostOutline,
} from "@mdi/js";
import SocialReportingHelpModal from "@/components/audience/social-reporting/SocialReportingHelpModal.vue";
import SocialReportingHealth from "@/components/audience/social-reporting/SocialReportingHealth.vue";
import SocialReportingResource from "@/components/audience/social-reporting/SocialReportingResource.vue";
import {
  readQueryString,
  replaceQueryParams,
} from "@/components/audience/social-reporting/queryState";
import RmrIconButton from "@/components/ui/actions/RmrIconButton.vue";
import RmrPageHero from "@/components/ui/layout/RmrPageHero.vue";
import RmrTabs from "@/components/ui/layout/RmrTabs.vue";
import { saveRmraView } from "@/utils/rmr-analytics";

const RESOURCES = ["posts", "accounts"];
const TABS = [
  { key: "posts", label: "Publications", icon: mdiPostOutline },
  { key: "accounts", label: "Comptes", icon: mdiAccountMultipleOutline },
];

export default {
  name: "ReportingSocial",
  components: {
    RmrIconButton,
    RmrPageHero,
    RmrTabs,
    SocialReportingHelpModal,
    SocialReportingHealth,
    SocialReportingResource,
  },
  data() {
    const requestedView = readQueryString(this.$route.query.view);
    const activeTab = RESOURCES.includes(requestedView)
      ? RESOURCES.indexOf(requestedView)
      : 0;
    return {
      activeTab,
      icons: { mdiChartTimelineVariant, mdiHelpCircleOutline },
      showHelp: false,
      tabs: TABS,
    };
  },
  computed: {
    activeResource() {
      return RESOURCES[this.activeTab];
    },
  },
  watch: {
    activeTab(value) {
      replaceQueryParams(this.$router, this.$route, ["view"], {
        view: RESOURCES[value],
      });
    },
    "$route.query.view"(value) {
      const requestedView = readQueryString(value);
      const nextTab = RESOURCES.includes(requestedView)
        ? RESOURCES.indexOf(requestedView)
        : 0;
      if (nextTab !== this.activeTab) this.activeTab = nextTab;
    },
  },
  mounted() {
    saveRmraView(this.$route);
  },
};
</script>

<style lang="scss" scoped>
.social-reporting-page__content {
  padding-bottom: $rmr-space-xl;
}

.social-reporting-page__panel {
  background: $rmr-surface-0;

  ::v-deep .social-reporting-table {
    border-radius: 0 !important;
    box-shadow: none !important;
  }
}

.social-reporting-page__tabs {
  padding: 0;
  background: $rmr-surface-0;
}
</style>
